var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5301 8.53014C15.3841 8.67614 15.192 8.75012 15 8.75012C14.808 8.75012 14.616 8.67715 14.47 8.53014L8.75002 2.81017V19.0001C8.75002 19.4141 8.41402 19.7501 8.00002 19.7501C7.58602 19.7501 7.25002 19.4141 7.25002 19.0001V2.81115L1.53005 8.53112C1.23705 8.82412 0.762018 8.82412 0.469018 8.53112C0.176018 8.23812 0.176018 7.76309 0.469018 7.47009L7.46902 0.470086C7.53802 0.401086 7.62091 0.346221 7.71291 0.308221C7.89591 0.232221 8.10291 0.232221 8.28591 0.308221C8.37791 0.346221 8.46105 0.401086 8.53005 0.470086L15.5301 7.47009C15.8231 7.76309 15.8231 8.23714 15.5301 8.53014Z",
    fill: "#25314C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.98025f3b9510e041f0d6f3823bd9e2db.svg";